import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Row, Spinner, UncontrolledCarousel } from 'reactstrap'
import { Link } from 'react-router-dom'
import { FaDiscord } from 'react-icons/fa6'

const Home : React.FC = () => {
  const [screenshotCount, setScreenshotCount] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)
 
  useEffect(() => {
    const fetchScreenshotCount = async () => {
      try {
        const response = await fetch('/api/screenshot/count')
        const data = await response.json()
        setScreenshotCount(data.count)
        setLoading(false)
      } catch (error) {
        console.error('Failed to fetch screenshot count', error)
        setLoading(false)
      }
    }
  
    fetchScreenshotCount()
  }, [])
  
  const items = [
    {
      src: require('../assets/img/theme/img-1-1200x1000.jpg'),
      altText: '',
      caption: 'Test',
      header: 'Test',
    },
    {
      src: require('../assets/img/theme/img-2-1200x1000.jpg'),
      altText: '',
      caption: 'Test',
      header: 'Test',
    },
  ]
  
  return (
    <div className="position-relative">
      <section className="section section-hero section-shaped">
        <div className="shape shape-style-1 shape-default">
          <span className="span-150"/>
          <span className="span-50"/>
          <span className="span-50"/>
          <span className="span-75"/>
          <span className="span-100"/>
          <span className="span-75"/>
          <span className="span-50"/>
          <span className="span-100"/>
          <span className="span-50"/>
          <span className="span-100"/>
        </div>
        <Container className="shape-container d-flex align-items-center py-lg">
          <div className="col px-0">
            <Row className="align-items-center justify-content-center">
              <Col className="text-center" lg="6">
                <img
                  alt="..."
                  className="img-fluid"
                  src="/logo192.png"
                  style={ { width: '150px' } }
                />
                <p className="lead">
                    Your Ultimate Tool for Effortless Screenshots. <br/>
										It&apos;s Free and Open Source.
                </p>
                { loading ? (
                  <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
                ): (
                  <h5>
                      Total Screenshots Uploaded: { screenshotCount }
                  </h5>
                ) }
                <div className="btn-wrapper mt-5">
                  <Button
                    className="btn-white btn-icon mb-3 mb-sm-0"
                    color="default"
                    href="https://github.com/Sorok-Dva/ScreenMe/releases/download/1.2.0/ScreenMe.exe"
                    size="lg"
                  >
                    <span className="btn-inner--icon mr-1">
                      <i className="ni ni-cloud-download-95"/>
                    </span>
                    <span className="btn-inner--text">Download ScreenMe</span>
                  </Button>{ ' ' }
                  <Button
                    className="btn-icon mb-3 mb-sm-0"
                    color="github"
                    href="https://github.com/Sorok-Dva/ScreenMe"
                    size="lg"
                    target="_blank"
                  >
                    <span className="btn-inner--icon mr-1">
                      <i className="fa fa-github"/>
                    </span>
                    <span className="btn-inner--text">
                      <span className="text-warning mr-1">Star us</span>
                          on Github
                    </span>
                  </Button>
                </div>
                <Button
                  href="https://discord.gg/b7kJM42QGn"
                  target="_blank"
                  style={ {
                    backgroundColor: '#7289da',
                    border: 'none',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '2rem',
                    padding: '0.5rem 1rem',
                  } }
                >
                  <FaDiscord size={ 24 } style={ { marginRight: '8px' } }/>
                    Join our Discord
                </Button>
                <div className="mt-5">
                  <small className="font-weight-bold mb-0 mr-2">
                      *proudly coded by
                  </small>
                  <Link to="https://github.com/Sorok-Dva">
                      Sorok-Dva
                  </Link>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <div className="separator separator-bottom separator-skew zindex-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="fill-white"
              points="2560 0 2560 100 0 100"
            />
          </svg>
        </div>
      </section>
      <section className="section section-lg pt-lg-0 mt--200">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <Row className="row-grid">
                <Col lg="4">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <div
                        className="d-flex justify-content-center align-items-center icon-xl icon-text-aligner icon-shape icon-shape-primary rounded-circle mb-4">
                        <h1><span role="img" aria-label="Photo">📸</span></h1>
                      </div>
                      <h4 className="text-primary text-uppercase">
                          Quickly capture any area on your screen
                      </h4>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <div
                        className="icon icon-shape icon-shape-success rounded-circle d-flex justify-content-center align-items-center icon-xl icon-text-aligner mb-4">
                        <h1><span role="img" aria-label="Save">💾</span></h1>
                      </div>
                      <h4 className="text-success text-uppercase">
                          User-friendly interface for seamless use
                      </h4>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <div
                        className="icon icon-shape icon-shape-info rounded-circle d-flex justify-content-center align-items-center icon-xl icon-text-aligner mb-4">
                        <h1><span role="img" aria-label="Share">🌐</span></h1>
                      </div>
                      <h4 className="text-blue text-uppercase">
                          Instantly share your captures online
                      </h4>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <div
                        className="d-flex justify-content-center align-items-center icon-xl icon-text-aligner icon-shape icon-shape-warning rounded-circle mb-4">
                        <h1><span role="img" aria-label="Edit">✏️</span></h1>
                      </div>
                      <h4 className="text-warning text-uppercase">
                          Advanced editing tools for precision
                      </h4>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <div
                        className="icon icon-shape icon-shape-light rounded-circle d-flex justify-content-center align-items-center icon-xl icon-text-aligner mb-4">
                        <h1><span role="img" aria-label="Search">🔍</span></h1>
                      </div>
                      <h4 className="text-teal text-uppercase">
                          Find and compare similar images
                      </h4>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <div
                        className="icon icon-shape icon-shape-dark rounded-circle d-flex justify-content-center align-items-center icon-xl icon-text-aligner mb-4">
                        <h1><span role="img" aria-label="Computer">🖥</span></h1>
                      </div>
                      <h4 className="text-dark text-uppercase">
                          Available on multiple platforms
                      </h4>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="section section-lg bg-gradient-default">
        <Container className="pt-lg">
          <Row className="text-center justify-content-center">
            <Col lg="10">
              <h2 className="display-3 text-blue">Why ScreenMe ?</h2>
              <p className="lead">
                  ScreenMe was created because of security concerns with Lightshot.
                  There have been security vulnerabilities in Lightshot that allow anyone to view screenshots
                  from other users. ScreenMe addresses this issue with robust
                  privacy settings that ensure only you control who sees your screenshots.
              </p>
              <p>
                  Additionally, Lightshot has issues with Facebook login, resulting in users losing access to their
                  galleries.
                  ScreenMe offers reliable tools to migrate your screenshots from Lightshot to ScreenMe.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <Container className="py-md">
        <Row className="justify-content-between align-items-center">
          <Col className="mb-5 mb-lg-0" lg="5">
            <h1 className="text-white font-weight-light">
              Demo images
            </h1>
            <p className="lead text-white mt-4">
              Here you can find some demo images that will show you how Screen.me behaves !
            </p>
            <Button
              className="btn-white mt-4"
              color="default"
              href="https://www.youtube.com/watch?v=bASccjpqklc"
            >
              See demo video
            </Button>
          </Col>
          <Col className="mb-lg-auto" lg="6">
            <div className="rounded shadow-lg overflow-hidden transform-perspective-right">
              <UncontrolledCarousel items={items} />
            </div>
          </Col>
        </Row>
      </Container>
      <div className="separator separator-bottom separator-skew">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
        >
          <polygon className="fill-white" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
  )
}

export default Home
